export default "__VITE_ASSET__D5aZxXlO__"